// LocationAdvantages.jsx
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LocationAdvantages.css";

function LocationAdvantages({ advantages }) {
  // State to keep track of which accordions are open
  const [openIndices, setOpenIndices] = useState([]);

  // Initialize all accordions as open when the component mounts or when 'advantages' changes
  useEffect(() => {
    if (advantages && advantages.length > 0) {
      const allIndices = advantages.map((_, index) => index);
      setOpenIndices(allIndices);
    }
  }, [advantages]);

  // Function to toggle the open state of a specific accordion
  const toggleCollapse = (index) => {
    setOpenIndices((prevOpenIndices) =>
      prevOpenIndices.includes(index)
        ? prevOpenIndices.filter((i) => i !== index)
        : [...prevOpenIndices, index]
    );
  };

  return (
    <div className="col-md-5 col-sm-12">
      <div className="location-section-features">
        <h2 className="text-center mb-4">Özellikler</h2>
        <div className="accordion" id="locationAdvantagesAccordion">
          {advantages.map((category, index) => {
            const isOpen = openIndices.includes(index);
            const collapseId = `collapse-${index}`;
            const headingId = `heading-${index}`;

            return (
              <div key={index} className="accordion-item mb-2">
                <h2 className="accordion-header" id={headingId}>
                  <button
                    className={`accordion-button ${isOpen ? "" : "collapsed"}`}
                    type="button"
                    onClick={() => toggleCollapse(index)}
                    aria-expanded={isOpen}
                    aria-controls={collapseId}
                  >
                    <i className={`me-2 text-secondary ${category.icon}`} />
                    <strong>{category.title}</strong>
                  </button>
                </h2>
                <div
                  id={collapseId}
                  className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                  aria-labelledby={headingId}
                >
                  <div className="accordion-body p-0">
                    <ul className="list-group list-group-flush">
                      {category.items.map((item, idx) => (
                        <li
                          key={idx}
                          className="list-group-item d-flex justify-content-between"
                        >
                          <span>{item}</span>
                          <i className="fas fa-check text-success me-2" />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LocationAdvantages;
